import React,{useRef} from "react";
import { Link } from "react-router-dom";

import logo_android from "../assets/images/logos/android.png"
import logo_android_studio from "../assets/images/logos/android_studio.png"
import logo_api from "../assets/images/logos/api.png"
import logo_app_store from "../assets/images/logos/app_store.png"
import logo_bootstrap from "../assets/images/logos/bootstrap.png"
import logo_cloud_hosting from "../assets/images/logos/cloud_hosting.png"
import logo_cpanel from "../assets/images/logos/cpanel.png"
import logo_elementor from "../assets/images/logos/elementor.png"
import logo_figma from "../assets/images/logos/figma.png"
import logo_firebase from "../assets/images/logos/firebase.png"
import git from "../assets/images/logos/git.png"
import logo_html from "../assets/images/logos/html.png"
import logo_ios from "../assets/images/logos/ios_white.png"
import logo_java from "../assets/images/logos/java.png"
import logo_js from "../assets/images/logos/js.png"
import logo_october from "../assets/images/logos/october.png"
import logo_paypal from "../assets/images/logos/paypal.png"
import logo_playconsole from "../assets/images/logos/playconsole.png"
import logo_php from "../assets/images/logos/php.png"
import logo_postman from "../assets/images/logos/postman.png"
import logo_react from "../assets/images/logos/react.png"
import logo_stripe from "../assets/images/logos/stripe.png"
import logo_vscode from "../assets/images/logos/vscode.png"
import logo_vue from "../assets/images/logos/vue.png"
import logo_laravel from "../assets/images/logos/laravel.png"
import logo_aws from "../assets/images/logos/aws.png"
import logo_mysql from "../assets/images/logos/logo_mysql.png"
import icon_more from "../assets/images/logos/more.png"
import logo_map from "../assets/images/logos/logo_map.png"
import logo_git from "../assets/images/logos/logo_git.png"
import logo_twilio from "../assets/images/logos/logo_twilio.png"




import BannerImg from "../assets/images/hero.jpg"
import linkedin from "../assets/images/logos/linkedin.png"
import skype from "../assets/images/logos/skype.png"


import Navbar from "../components/navbar";
import About from "../components/about";
import Services from "../components/services";
import OurProjects from "../components/ourProjexts";
import WorkWith from "../components/workwith";
import Features from "../components/features";
import Clients from "../components/clients";
import GetInTuch from "../components/getInTuch";
import Footer from "../components/footer";
import Switcher from "../components/switcher";

import { TypeAnimation } from 'react-type-animation';

export default function IndexTwo(){
    const homeSectionRef = useRef(null);
    const techStackSectionRef = useRef(null);
    const projectSectionRef = useRef(null);
    const aboutSectionRef = useRef(null);
    const contactSectionRef = useRef(null);
    const servicesSectionRef = useRef(null);

    const scrollToHomeSliderSection = () => {
        homeSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToProjectSection = () => {
        projectSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToAboutSection = () => {
        aboutSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToContactSection = () => {
        contactSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    };
    const scrollToServicesSection = () => {
        servicesSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const scrollToTechStackSection = () => {
        techStackSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const logo = [
        { name: "iOS", logo: logo_ios },
        { name: "Android", logo: logo_android },
        { name: "Firebase", logo: logo_firebase },
        { name: "Laravel", logo: logo_laravel },
        { name: "React", logo: logo_react },    
        { name: "Vue", logo: logo_vue },
        { name: "Stripe", logo: logo_stripe },            
        { name: "October CMS", logo: logo_october },        
        { name: "Postman", logo: logo_postman },
        { name: "Android Studio", logo: logo_android_studio },
        { name: "Api Dev", logo: logo_api },
        { name: "App Store", logo: logo_app_store },
        { name: "Bootstrap", logo: logo_bootstrap },
        { name: "Cloud Hosting", logo: logo_cloud_hosting },
        { name: "Cpanel", logo: logo_cpanel },
        { name: "Elementor", logo: logo_elementor },
        { name: "Figma", logo: logo_figma },
        { name: "Html", logo: logo_html },
        { name: "Vs Code", logo: logo_vscode },
        { name: "Java", logo: logo_java },
        { name: "Javascript", logo: logo_js },
        { name: "Paypal", logo: logo_paypal },
        { name: "Play Console", logo: logo_playconsole },
        { name: "PHP", logo: logo_php },
        { name: "AWS", logo: logo_aws },
        { name: "Google Maps Api", logo: logo_map },
        { name: "My SQL", logo: logo_mysql },
        { name: "Git", logo: logo_git },
        { name: "Twilio", logo: logo_twilio },
    ];
    
    const linkReferences = {
        'homeSliderSection':scrollToHomeSliderSection,
        'workSection':scrollToProjectSection,     
        'aboutSection':scrollToAboutSection,
        'contactSection':scrollToContactSection,
        'servicesSectionRef':scrollToServicesSection,
    }
      
      
    return(
        <>
        <Navbar linkReferences={linkReferences}/>
        <section ref={homeSectionRef} className="relative table w-full md:py-44 py-36 overflow-hidden before:content-[''] before:absolute before:start-1/2 before:-translate-x-1/2 rtl:before:translate-x-1/2 before:bottom-1/2 before:translate-y-1/2 before:w-[40rem] before:h-[20rem] before:rounded-[18rem] ltr:before:rotate-[135deg] rtl:before:rotate-[45deg] before:bg-orange-500/10 dark:before:bg-orange-500/20">
            <div className="container relative">
                <div className="grid grid-cols-1 text-center">
                    <div>
                        <img src={BannerImg} className="h-28 w-28 rounded-full shadow-md dark:shadow-gray-800 mx-auto" alt=""/>

                        <h5 className="font-semibold leading-normal text-[20px] mt-6">Hi, I'm 
                            <TypeAnimation
                                sequence={[
                                    // Same substring at the start will only be typed out once, initially
                                    'Gohar Ali',
                                    500, // wait 1s before replacing "Mice" with "Hamsters"
                                    'Web Developer',
                                    500,
                                    'Mobile Developer',
                                    500, 
                                    'Website Designer',
                                    500,                                    
                                    'UI/UX Designer',
                                    500,
                                ]}
                                wrapper="span"
                                speed={10}
                                className="typewrite ms-3"
                                repeat={Infinity}
                                />

                        </h5>
                    
                        <h5 className="md:text-5xl md:leading-normal text-3xl leading-normal font-bold mt-3">Full Stack Developer ✪</h5>
                        

                        <p className="text-slate-400 dark:text-white/60 mx-auto text-[17px] max-w-xl mt-4">One solution for all your digital needs—Web Development, Mobile Apps, Backend Architecture, API Development, and UI/UX Design.</p>

                        <div className="relative mt-6">
                            <Link onClick={scrollToProjectSection} className="py-2 px-5 inline-flex items-center font-medium tracking-wide border align-middle duration-500 text-[15px] text-center bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white rounded-xl">Explore Work <i className="mdi mdi-arrow-right ms-2"></i></Link>
                            <Link to="https://drive.google.com/file/d/1hCTiRpak2j6NcgcrYcklQ1ygfJr40Pcw/view?usp=sharing" target="new" className="py-2 px-5 inline-flex items-center font-medium tracking-wide border align-middle duration-500 text-[15px] text-center  hover:bg-orange-600 border-orange-500 hover:border-orange-600 rounded-xl ms-5">Download CV <i className="mdi mdi-download ms-2"></i></Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container relative mt-16">
                <div className="grid md:grid-cols-10 sm:grid-cols-5 grid-cols-4 justify-center gap-6">
                    {logo.slice(0, 9).map((item,index)=>{
                        return(
                        <div key={index} className="w-12 h-12 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 flex justify-center items-center rounded-xl mx-auto py-4">
                            <img src={item.logo} title={item.name} className="h-7" alt=""/>
                        </div>
                        )
                    })}
                    <Link onClick={scrollToTechStackSection} className="w-22 h-12 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 flex justify-center items-center rounded-xl mx-auto py-4">
                        <img src={icon_more} title='More' className="h-4" alt=""/> <span className="ms-2">More</span>
                    </Link>
                </div>
            </div>
        </section>
        <section  className="relative overflow-hidden md:pb-24 pb-16">
            <div ref={aboutSectionRef}>            
            <About/>
            </div>
            <div ref={servicesSectionRef}>            
            <Services/>
            </div>
            <div id="sectionMyProjects" ref={projectSectionRef}>
                <OurProjects containerFuild = {true}/>
            </div>
            <div ref={techStackSectionRef} >
            <Features logo={logo}/>
            </div>
            <WorkWith containerFuild = {true}/>            
            <Clients/>
            <div id="contact-me" ref={contactSectionRef}><GetInTuch/></div>
        </section>
        <Footer/>
        <Switcher/>
        </>
    )
}